import type { AuthUser } from "@models/AuthUser";

/**
 * Session snapshot, or `null` when there is no established session.
 *
 * Narrow pick of AuthUser — only what policy compiles from. Prop-driven rather
 * than read from context: the caller must gate on session status, because a
 * signed-out user can still have cached current-user data.
 */
export type AuthZSession = Pick<AuthUser, "role" | "organization"> | null;

/**
 * Session gate for AuthZProvider: ready + user → snapshot; otherwise null.
 * Extracted so the signed-out-with-cached-user case is unit-testable without
 * mounting AuthUserProvider.
 */
export function authZSessionFrom(
  sessionReady: boolean,
  user: Pick<AuthUser, "role" | "organization"> | null | undefined
): AuthZSession {
  return sessionReady && user
    ? { role: user.role, organization: user.organization }
    : null;
}
